export default __webpack_public_path__ + "maps-examples-live-data-thumbnail-960-1d18f31804cfc1ebf3d9de34f8097be3.png";